import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import simpleTaskScheduleService from '../../service/simpleTaskSchedule.service';
import { MonthDaysList, UnitList, WeekDaysList } from '../../config/simpleTaskSchedule';
import dayjs from 'dayjs';

export const SimpleTaskScheduleReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    simpleTaskScheduleService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'startDate',
      type: 'date',
      headerName: 'Kezdő dátum',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
    },
    {
      field: 'endDate',
      type: 'date',
      headerName: 'Befejező dátum',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
    },
    {
      field: 'unit',
      headerName: 'Rendszeresség',
      type: 'singleSelect',
      valueOptions: UnitList,
      renderCell: (data) => {
        return UnitList.find((unit) => unit.value === data.row.unit)?.label;
      },
    },
    {
      field: 'every',
      headerName: 'Ismétlődés gyakorisága',
      type: 'number',
    },
    {
      field: 'weekday',
      headerName: 'Hét napja',
      type: 'singleSelect',
      valueOptions: WeekDaysList,
      renderCell: (data) => {
        return WeekDaysList.find((weekday) => weekday.value === data.row.weekday)?.label;
      },
    },
    {
      field: 'monthDay',
      headerName: 'Hónap napja',
      type: 'singleSelect',
      valueOptions: MonthDaysList,
      renderCell: (data) => {
        return MonthDaysList.find((monthDay) => monthDay.value === data.row.monthDay)?.label;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.SimpleTaskShedule}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
